import type { Answers } from '@jlg-website/shared';

export function compute(answers: Answers, leadScoreBaseline: number) {
  const score = Object.values(answers).reduce((acc, { score }) => {
    return acc + score.reduce((acc, v) => acc + v, 0);
  }, 0);

  return score + leadScoreBaseline;
}
